export default __webpack_public_path__ + "static/fiu_logo.inline-c54287f4376cdef67a90835d483814a7.png";